import React, { useEffect } from 'react'

import { Grid, IconButton, InputAdornment, TextField, Typography } from '@material-ui/core'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import Autocomplete from '@material-ui/lab/Autocomplete'
import DeleteIcon from '@material-ui/icons/Delete'
import { CardVestigio } from 'components/Cards/CardVestigio'
import { SecaoGenerica } from 'components'
import tiposDeExame from 'globals/tiposDeExame'

export const FormDNA = (props) => {
  moment.locale('pt-br', localization)
  const { form, handleChange, listaVitima, listaPericiandos } = props

  const getLabelObjetivoExame = (value) => {
    if (value === 'CONFRONTO_VESTIGIOS_MESMA_PESSOA') {
      return 'Confronto genético entre os vestígios para determinar se pertencem a mesma pessoa'
    }

    if (value === 'CONFRONTO_VESTIGIOS_QUESTIONADA_REFERENCIA') {
      return 'Confronto genético entre vestígios questionados e amostra de referência da vítima'
    }

    if (value === 'CONFRONTO_VESTIGIOS_REFERENCIA_SUSPEITO') {
      return 'Confronto genético entre vestígios questionados e amostra de referência do(s) suspeito(s) relacionado(s)'
    }

    if (value === 'VINCULO_GENETICO_VITIMA_IDENTIFICACAO') {
      return 'Vínculo genético entre a amostra questionada da vítima com a amostra de referência de eventual familiar, para fins de identificação humana'
    }

    if (value === 'VINCULO_GENETICO_VITIMA_PARTERNIDADE') {
      return 'Vínculo genético entre a amostra questionada da vítima com a amostra de referência de eventual familiar, para fins de Paternidade Criminal'
    }

    if (value === 'CONFRONTO_VESTIGIOS_QUESTIONADA_BANCO_PERFIL') {
      return 'Confronto genético entre vestígio questionado e o Banco de Perfil Genético Criminal para identificar eventuais suspeitos'
    }

    if (value === 'OUTRO') {
      return 'Outro'
    }
    return ''
  }

  const getPropVestigioExameSelecionado = (prop, idVestigio) => {
    const listaObjetosExaminadosDeExame = form.listaObjetosExaminados
    let result = null
    listaObjetosExaminadosDeExame.forEach((objetoExaminado) => {
      if (objetoExaminado.id === idVestigio) {
        result = objetoExaminado[prop]
      }
    })
    return result
  }

  const handleChangeProVestigio = (idVestigio, prop, newValue) => {
    let listaObjetosExaminados = []
    if (form.listaObjetosExaminados?.length) {
      listaObjetosExaminados = form.listaObjetosExaminados?.map((objetoExaminado) => {
        if (objetoExaminado.id === idVestigio) {
          return {
            ...objetoExaminado,
            [prop]: newValue,
          }
        }

        return objetoExaminado
      })
    }

    handleChange('listaObjetosExaminados', listaObjetosExaminados)
  }

  return (
    <>
      <Grid item md={6} sm={6} xs={12}>
        <Autocomplete
          name="vitima"
          value={form.vitima}
          noOptionsText="Sem informações"
          options={listaVitima || []}
          onChange={(event, newValue) => handleChange('vitima', newValue)}
          disabled={!form.tipoEx}
          getOptionLabel={(option) => {
            if (Object.prototype.hasOwnProperty.call(option, 'nic')) return `CADÁVER - Nome: ${option.nome ? option.nome?.toUpperCase() : 'NÃO IDENTIFICADO'} - NIC: ${option.nic ? option.nic : 'NÃO INFORMADO'}`
            if (Object.prototype.hasOwnProperty.call(option, 'cpf')) return `PERICIANDO - ${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
          }}
          renderOption={(option) => {
            if (Object.prototype.hasOwnProperty.call(option, 'nic')) return `CADÁVER - Nome: ${option.nome ? option.nome?.toUpperCase() : 'NÃO IDENTIFICADO'} - NIC: ${option.nic ? option.nic : 'NÃO INFORMADO'}`
            if (Object.prototype.hasOwnProperty.call(option, 'cpf')) return `PERICIANDO - ${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="VÍTIMA"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      </Grid>

      <Grid item md={6} sm={6} xs={12}>
        <Autocomplete
          name="suspeito"
          value={form.suspeito}
          noOptionsText="Sem informações"
          getOptionSelected={(option, value) => option.id === value.id}
          options={listaPericiandos || []}
          onChange={(event, newValue) => handleChange('suspeito', newValue)}
          disabled={!form.tipoEx}
          getOptionLabel={(option) => {
            return `${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
          }}
          renderOption={(option) => {
            return `${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="SUSPEITO"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      </Grid>

      {form.objetivoExame !== 'OUTRO' ? (
        <Grid item md={12} sm={12} xs={12}>
          <Autocomplete
            name="objetivoExame"
            value={form.objetivoExame}
            noOptionsText="Sem informações"
            options={['CONFRONTO_VESTIGIOS_MESMA_PESSOA', 'CONFRONTO_VESTIGIOS_QUESTIONADA_REFERENCIA', 'CONFRONTO_VESTIGIOS_REFERENCIA_SUSPEITO', 'VINCULO_GENETICO_VITIMA_IDENTIFICACAO', 'VINCULO_GENETICO_VITIMA_PARTERNIDADE', 'CONFRONTO_VESTIGIOS_QUESTIONADA_BANCO_PERFIL', 'OUTRO']}
            onChange={(event, newValue) => handleChange('objetivoExame', newValue)}
            required
            getOptionLabel={(option) => {
              return getLabelObjetivoExame(option)
            }}
            renderOption={(option) => {
              return getLabelObjetivoExame(option)
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                variant="outlined"
                label="OBJETIVO DO EXAME"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
      ) : (
        <Grid item md={12} sm={12} xs={12}>
          <TextField
            label="OBJETIVO -  TEXTO LIVRE"
            name="outroObjetivoExame"
            variant="outlined"
            value={form.outroObjetivoExame}
            onChange={(event) => {
              handleChange('outroObjetivoExame', event.target.value)
            }}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton onClick={(e) => handleChange('objetivoExame', null)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      )}

      <Grid item md={12} sm={12} xs={12}>
        <TextField
          label="OUTRAS OBSERVAÇÕES"
          name="outraObservacoes"
          variant="outlined"
          value={form.outraObservacoes}
          onChange={(event) => {
            handleChange('outraObservacoes', event.target.value)
          }}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      {form.listaObjetosExaminados && form.listaObjetosExaminados.length > 0 && (
        <Grid item xs={12}>
          <SecaoGenerica titulo="INFORMAÇÕES SOBRE OS VESTÍGIOS" spacing={2}>
            {form.listaObjetosExaminados.map((objeto) => (
              <Grid item xs={12} key={objeto.id} style={{ marginTop: '10px' }}>
                <CardVestigio
                  vestigio={objeto}
                  formDNA={true}
                  comPrioridade={form.listaObjetosExaminados?.length > 2}
                  prioridade={getPropVestigioExameSelecionado('prioridade', objeto.id)}
                  justificativa={getPropVestigioExameSelecionado('justificativa', objeto.id)}
                  materialBiologico={getPropVestigioExameSelecionado('tipoMaterialBiologico', objeto.id)}
                  tipoAmostra={getPropVestigioExameSelecionado('tipoAmostra', objeto.id)}
                  handleChangeProVestigio={handleChangeProVestigio}
                  handleClick={() => {}}
                />
              </Grid>
            ))}
          </SecaoGenerica>
        </Grid>
      )}
    </>
  )
}
